import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { TextSmall } from 'components/chroma/extended';

const HelpTextContainer = styled.div`
  .c-text {
    margin: 0;
  }
`;

const HelpTextSpacer = styled.div`
  margin-top: 0.5em;
`;

interface HelpTextWrapperProps {
  helpTexts: string[];
}

export const BottomLineHelpTextWrapper: FunctionComponent<HelpTextWrapperProps> = ({
  helpTexts,
  children,
}) => (
  <HelpTextContainer>
    {children}
    <HelpTextSpacer>
      {helpTexts.map((helpText) => (
        <TextSmall key={helpText}>{helpText}</TextSmall>
      ))}
    </HelpTextSpacer>
  </HelpTextContainer>
);

export default BottomLineHelpTextWrapper;
